// assets
import TeamOutlined from '@ant-design/icons/TeamOutlined';
import SafetyOutlined from '@ant-design/icons/SafetyOutlined';
import AppstoreOutlined from '@ant-design/icons/AppstoreOutlined';
import SettingOutlined from '@ant-design/icons/SettingOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import BankOutlined from '@ant-design/icons/BankOutlined';
import WalletOutlined from '@ant-design/icons/WalletOutlined';
import ProjectOutlined from '@ant-design/icons/ProjectOutlined';
import FolderOpenOutlined from '@ant-design/icons/FolderOpenOutlined';
import FileTextOutlined from '@ant-design/icons/FileTextOutlined';
import FileOutlined from '@ant-design/icons/FileOutlined';
import ShoppingCartOutlined from '@ant-design/icons/ShoppingCartOutlined';
import TruckOutlined from '@ant-design/icons/TruckOutlined';
import InboxOutlined from '@ant-design/icons/InboxOutlined';
import GiftOutlined from '@ant-design/icons/GiftOutlined';
import PrinterOutlined from '@ant-design/icons/PrinterOutlined';
import AIIcon from 'components/icons/AIIcon';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = { TeamOutlined, SafetyOutlined, AppstoreOutlined, SettingOutlined, UserOutlined, BankOutlined, WalletOutlined, ProjectOutlined, FolderOpenOutlined, FileTextOutlined, FileOutlined, ShoppingCartOutlined, TruckOutlined, InboxOutlined, GiftOutlined, PrinterOutlined, AIIcon };

// ==============================|| MENU ITEMS - PAGES ||============================== //

const pages: NavItemType = {
  id: 'group-pages',
  title: 'pages',
  type: 'group',
  children: [
    // 👇 Menu "Administração"
    {
      id: 'administration',
      title: 'administration',
      type: 'collapse',
      icon: icons.SettingOutlined,
      children: [
        {
          id: 'company',
          title: 'company',
          type: 'item',
          icon: icons.BankOutlined,
          url: '/company'
        },
        {
          id: 'departments',
          title: 'departments',
          type: 'item',
          icon: icons.AppstoreOutlined,
          url: '/departments'
        },
        {
          id: 'roles',
          title: 'roles',
          type: 'item',
          icon: icons.SafetyOutlined,
          url: '/roles'
        },
        {
          id: 'collaborators',
          title: 'users',
          type: 'item',
          icon: icons.TeamOutlined,
          url: '/users'
        },
        {
          id: 'clients',
          title: 'customer',
          type: 'item',
          icon: icons.UserOutlined,
          url: '/clients'
        },
        {
          id: 'label-calibration',
          title: 'Calibragem de Etiquetas',
          type: 'item',
          icon: icons.PrinterOutlined,
          url: '/label-calibration'
        }
      ]
    },
    // 👇 Menu "Operações"
    {
      id: 'operations',
      title: 'Operações',
      type: 'collapse',
      icon: icons.ShoppingCartOutlined,
      children: [
        {
          id: 'products',
          title: 'Produtos',
          type: 'item',
          icon: icons.GiftOutlined,
          url: '/products'
        },
        {
          id: 'orders',
          title: 'Pedidos',
          type: 'item',
          icon: icons.ShoppingCartOutlined,
          url: '/orders'
        },
        {
          id: 'logistics',
          title: 'Logística',
          type: 'item',
          icon: icons.TruckOutlined,
          url: '/logistics'
        },
        {
          id: 'billing',
          title: 'Faturamento',
          type: 'item',
          icon: icons.FileTextOutlined,
          url: '/billing'
        },
        {
          id: 'warehouse-map',
          title: 'Mapa de Estoque',
          type: 'item',
          icon: icons.InboxOutlined,
          url: '/warehouse-map'
        },
        {
          id: 'stock-check',
          title: 'Conferência de estoque',
          type: 'item',
          icon: icons.SafetyOutlined,
          url: '/stock-check'
        },
        {
          id: 'floor-workers',
          title: 'Funcionários do galpão',
          type: 'item',
          icon: icons.TeamOutlined,
          url: '/floor-workers'
        },
        {
          id: 'taxes',
          title: 'Gerenciar taxas',
          type: 'item',
          icon: icons.WalletOutlined,
          url: '/taxes'
        },
        {
          id: 'catalog-health',
          title: 'Saúde do catálogo',
          type: 'item',
          icon: icons.SafetyOutlined,
          url: '/catalog-health'
        },
        {
          id: 'assistant',
          title: 'Assistente',
          type: 'item',
          icon: icons.AIIcon,
          url: '/assistant'
        },
      ]
    }
  ]
};

export default pages;
